module.exports = __webpack_public_path__ + "img/app_active.1ccb32c7.svg";